import React from 'react';
import PDFViewer from 'pdf-viewer-reactjs';

const link = 'https://fh.filgolf.com/files/ele/J_DIS_Certification.pdf';

export default function J() {
  return (
    <>
      <h5 className="is-size-5 mb-4">
        <strong>J. DIS Certification</strong>
      </h5>
      <a className="button  is-link" href={link} download>
        DOWNLOAD
      </a>
      <PDFViewer
        document={{
          url: link
        }}
        rotationAngle={0}
        css="customViewer"
      />
    </>
  );
}
